/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutomationsList/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import Content from './Content/index'
import CopyAction from './CopyAction/index'
import EnableAutomationHub from './EnableAutomationHub/index'
import EnabledTag from './EnabledTag/index'
import Filters from './Filters/index'
import LocationChooser from './LocationChooser/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AutomationsList({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="AutomationsList.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Zvrkyy': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pl-2-Zvrkyy': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Zvrkyy': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<LocationChooser
  viewPath={`${viewPath}/LocationChooser`}
/>
<div
  data-testid="AutomationsList.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-4-Zvrkyy': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AutomationsList.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="AutomationsList.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Automation Hub"
/>
<EnabledTag
  viewPath={`${viewPath}/EnabledTag`}
/>
</div>
<div
  data-testid="AutomationsList.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Enhance your workflow management with the Greyfinch Automation Hub."
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 color={dtColorsNeutral900}
 marginTop={dtSpaceXs}
 weight="medium"
 size="xmedium"
 text="Learn how this works."
 goTo="https://support.greyfinch.com/hc/en-us/articles/24002245316621-Automation-Hub"
/>
</div>
</div>
<div
  data-testid="AutomationsList.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<CopyAction
  viewPath={`${viewPath}/CopyAction`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
</div>
<div
  data-testid="AutomationsList.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-Zvrkyy': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={dtSpaceS}
 theme="light"
/>
<div
  data-testid="AutomationsList.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="AutomationsList.Horizontal:4"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal4}`}
>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
</div>
<EnableAutomationHub
  viewPath={`${viewPath}/EnableAutomationHub`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}